import React, { useEffect, useState } from "react";
import { Table, Row, Col, Select, Form, DatePicker, Input, Button, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { dropdownService, reportService } from "../../../services";
import { handlePDFDownload, handlePrint, exportToExcel } from "../../../utils/printing";

const { Title } = Typography;

function BankCollectionAmount() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [bankCollection, setBankCollection] = useState([]);
  const [allbankCollection, setAllBankCollection] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [payload, setPayload] = useState(null);
  const [paymentModes, setPaymentModes] = useState([]);
  const [banks, setBanks] = useState([]);
  const [companies, setCompanies] = useState([]);

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Company",
      dataIndex: "Company",
      key: "Company",
      render: (text) => text || "N/A",
    },
    {
      title: "Transaction Id",
      dataIndex: "Transaction Id",
      key: "Transaction Id",
    },
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
    },
    {
      title: "Invoice#",
      dataIndex: "Invoice #",
      key: "Invoice #",
    },

    {
      title: "Payment Mode",
      dataIndex: "Payment Mode",
      key: "Payment Mode",
    },
    {
      title: "Bank",
      dataIndex: "Bank",
      key: "Bank",
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
    },
  ];

  const onFinish = (values) => {
    const payload = Object.fromEntries(
      Object.entries({
        ...values,
        from_date: values.from_date?.format("YYYY-MM-DD"),
        to_date: values.to_date?.format("YYYY-MM-DD"),
      }).filter(([_, value]) => value != null)
    );
    setPayload(payload);
    initialize(pagination.current, pagination.pageSize, payload);
  };

  const initialize = async (
    page = 1,
    pageSize = pagination.pageSize,
    payload = null
  ) => {
    setLoading(true);
    const { success, data } = await reportService.BankCollectionAmount(
      page,
      payload
    );
    setLoading(false);
    if (success) {
      setBankCollection(data);
      setPagination((prev) => ({
        ...prev,
        total: data.pagination.total,
        current: page,
        pageSize,
      }));
      getAll();
    }
    setLoading(false);
  };

  const getPaymentModes = async () => {
    const response = await dropdownService.fetchPaymentModes();
    if (response.success) {
      setPaymentModes(response.data);
    }
  };
  const getBanks = async () => {
    const response = await dropdownService.fetchBanks();
    if (response.success) {
      setBanks(response.data);
    }
  };
  const getCompanies = async () => {
    const response = await dropdownService.fetchCompanies();
    if (response.success) {
      setCompanies(response.data);
    }
  };

  const getAll = async () => {
    const { data } = await reportService.BankCollectionAmount(1, payload, true);
    setAllBankCollection(data.data);
  }

  useEffect(() => {
    getPaymentModes();
    getBanks();
    getCompanies();
  }, []);
  return (
    <>
      <Title level={5}>Bank Collection Amount</Title>
      <Form
        requiredMark={false}
        layout="vertical"
        form={form}
        onFinish={onFinish}
      >
        <Row gutter={24} className="mt-8">
          <Col span={4}>
            <Form.Item label="From date" name="from_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item label="To date" name="to_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={4}>
            <Form.Item label="Payment Mode" name="payment_mode">
              <Select placeholder="">
                {paymentModes.map((mode) => (
                  <Select.Option key={mode.id} value={mode.name}>
                    {mode.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Bank" name="bank">
              <Select placeholder="">
                {banks.map((bank) => (
                  <Select.Option key={bank.id} value={bank.id}>
                    {bank.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Company" name="company">
              <Select placeholder="">
                {companies.map((comp) => (
                  <Select.Option key={comp.id} value={comp.id}>
                    {comp.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item label={<></>}>
              <Button type="primary" htmlType="submit">
                <SearchOutlined style={{ fontSize: "15px" }} />
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Col span={24}>
        <Row
          gutter={0}
          style={{
            padding: "8px",
            marginTop: "2px",
            background: "#F2F2F7",
            borderRadius: "4px",
          }}
          className="flex justify-between"
        >
          <Col span={12}>
            <div className="flex">
              <Button onClick={() => handlePrint(allbankCollection, columns, "Bank Collection Amount")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }} >
                <span style={{ fontWeight: "bold", padding: "3px" }}>Print</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <FaRegFile style={{ fontSize: "20px" }} />
              </Button> */}

              <Button onClick={() => exportToExcel(allbankCollection, "Bank_Collection_Amount.xlsx")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>Excel</span>
              </Button>

              <Button onClick={() => handlePDFDownload(allbankCollection, columns, "Bank Collection Amount", false)} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>PDF</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <RiFileCopyLine style={{ fontSize: "24px" }} />
              </Button> */}
            </div>
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              className="w-auto lg:w-2/5"
            />
          </Col>
        </Row>
        <div id="printable-table">

          <Table
            columns={columns}
            scroll={{ x: "max-content" }}
            loading={loading}
            pagination={{
              current: pagination.current,
              total: pagination.total,
              pageSize: pagination.pageSize,
              onChange: (page) => initialize(page, pagination.pageSize, payload),
              showSizeChanger: false,
            }}
            dataSource={bankCollection.data}
            style={{ marginTop: "10px" }}
            summary={() => (
              <Table.Summary.Row className="font-bold">
                <Table.Summary.Cell
                  colSpan={columns.length - 2}
                ></Table.Summary.Cell>
                <Table.Summary.Cell>Total Amount Collected:</Table.Summary.Cell>
                <Table.Summary.Cell colSpan={2}>
                  ${parseFloat(bankCollection?.totalAmount || 0).toFixed(2)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            )}
          />
        </div>
      </Col>
    </>
  );
}

export default BankCollectionAmount;
